import React from 'react';
import { 
  Box, 
  Typography, 
  Grid, 
  Card, 
  CardMedia, 
  CardContent, 
  Button,
  IconButton
} from '@mui/material';
import { Favorite, DeleteOutline, ShoppingCart } from '@mui/icons-material';
import { useWishlist } from '../../../context/WishlistContext';
import { useCart } from '../../../context/CartContext';
import { useNavigate } from 'react-router-dom';

const Wishlist = () => {
  const { wishlist, toggleWishlist } = useWishlist();
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const handleAddToCart = (product) => {
    addToCart(product, 1, product.weight || '1 PC');
  };

  return (
    <Box>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Favorite sx={{ color: 'error.main' }} />
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          My Wishlist
        </Typography>
      </Box>

      {wishlist.length > 0 ? (
        <Grid container spacing={3}>
          {wishlist.map((item) => (
            <Grid item xs={12} sm={6} key={item.id}>
              <Card sx={{ display: 'flex', borderRadius: 2, border: '1px solid #eee', boxShadow: 'none' }}>
                <CardMedia
                  component="img"
                  sx={{ width: 120, objectFit: 'contain', cursor: 'pointer', p: 1 }}
                  image={item.image || item.featuredImage}
                  alt={item.name}
                  onClick={() => navigate(`/product/${item.slug}`)}
                />
                <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                  <CardContent sx={{ flex: '1 0 auto', p: 2, cursor: 'pointer' }} onClick={() => navigate(`/product/${item.slug}`)}>
                    <Typography component="div" variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.2, mb: 1 }}>
                      {item.name}
                    </Typography>
                    <Typography variant="h6" color="primary.main" sx={{ fontWeight: 700 }}>
                      ₹{item.price}
                    </Typography>
                  </CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', p: 1, gap: 1 }}>
                    <Button 
                      variant="contained" 
                      color="primary" 
                      size="small" 
                      startIcon={<ShoppingCart />}
                      onClick={() => handleAddToCart(item)}
                      sx={{ flex: 1 }}
                    >
                      Add to Cart
                    </Button>
                    <IconButton color="error" onClick={() => toggleWishlist(item)}>
                      <DeleteOutline />
                    </IconButton>
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box sx={{ textAlign: 'center', py: 8, bgcolor: '#F8FAFC', borderRadius: 2 }}>
          <Favorite sx={{ fontSize: 60, color: '#CBD5E1', mb: 2 }} />
          <Typography variant="h6" color="text.secondary">Your wishlist is empty</Typography>
          <Button variant="outlined" sx={{ mt: 3 }} onClick={() => navigate('/shop')}>
            Explore Products
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default Wishlist;
